// Composant responsive qui bascule automatiquement entre desktop et mobile pour l'interface Professeur
import React from "react";
import { useExplanationResponsive } from "../../../hooks/useResponsive";
import TeacherExplanations from "./index";
import MobileTeacherExplanations from "./MobileTeacherExplanations";

const ResponsiveTeacherExplanations: React.FC = () => {
  const { shouldUseMobileLayout } = useExplanationResponsive();

  // Basculer automatiquement entre les versions desktop et mobile
  if (shouldUseMobileLayout) {
    return <MobileTeacherExplanations />;
  }

  return <TeacherExplanations />;
};

export default ResponsiveTeacherExplanations;
